// @flow
import throttle from 'lodash/throttle';

import { scribeSetFontSize } from '../config';
import { UserError } from '../../errors';
import { authInstance, getFirestore } from '../../firebase';
import { users } from '../../services/api/ava';

export const firebaseLoginSuccess = (user: Object, isNew: boolean) => {
  return {
    type: 'FIREBASE_USER_LOGIN_SUCCESS',
    user,
    isNew,
  };
};

export const firebaseLogout = () => ({
  type: 'FIREBASE_USER_LOGOUT',
});

export const updateScribeRemainingTime = (scribeRemainingTimeMs: number) => ({
  type: 'UPDATE_SCRIBE_REMAINING_TIME',
  scribeRemainingTimeMs,
});

export const updatePaidASRCreditTime = (paidASRCreditTime: number) => ({
  type: 'UPDATE_PAID_ASR_CREDIT_TIME',
  paidASRCreditTime,
});

export const decreasePaidASRCreditTime = () => ({
  type: 'DECREASE_PAID_ASR_CREDIT_TIME',
});

export const decreaseScribeRemainingTime = () => ({
  type: 'DECREASE_SCRIBE_REMAINING_TIME',
});

export function fetchScribeSettings() {
  return async (dispatch: Function, getState: Function) => {
    const {
      scribeSession: { captioner: user },
    } = getState();
    if (!user?.avaId) {
      throw new UserError('No "avaId" found in "user" object');
    }

    const docRef = (await getFirestore()).collection('users').doc(user.avaId);
    const doc = await docRef.get();
    const { settings } = doc.data();
    if (settings && settings.webFontSize) {
      dispatch(scribeSetFontSize(settings.webFontSize));
    }
  };
}

const updateFontSize = throttle(
  (avaId: string, uid: string, fontSize: number) =>
    users.updateSettings({
      avaId,
      firebaseAuthUID: uid,
      settings: {
        webFontSize: fontSize,
      },
    }),
  2000
);

export const scribeSetFontSizeAndSave = (fontSize: number) => (dispatch: Function, getState: Function) => {
  const {
    scribeSession: { captioner: user },
  } = getState();
  updateFontSize(user.avaId, authInstance.currentUser.uid, fontSize);
  return dispatch(scribeSetFontSize(fontSize));
};
